import { HelpOutline } from '@mui/icons-material';
import { Box, Link, TableCell, TableRow, Typography } from '@mui/material';
import { DisclosureTooltip } from '../../../../DisclosureTooltip';
import { NWGreenIcon } from './NWGreenIcon';

type Props = {
  headings: { label?: string; labelTooltip?: string }[];
  shouldApplyStylingUpdates?: boolean;
};

export default function SummaryTableHead({ headings, shouldApplyStylingUpdates = false }: Props) {
  return (
    <TableRow
      sx={{
        '& th': {
          border: 'none',
          borderBottom: '1px solid',
          padding: 1,
          paddingTop: 0,
          textAlign: shouldApplyStylingUpdates ? 'center' : 'left',
          typography: { xs: 'textSmall', md: 'textBold' },
          fontWeight: { xs: '400' },
          '&:first-of-type': {
            paddingLeft: 0,
          },
        },
      }}
    >
      {headings.map(heading => {
        const shouldUseRatingWithIcon =
          heading.label === 'NerdWallet rating' && shouldApplyStylingUpdates;
        return (
          <TableCell key={heading.label}>
            {shouldUseRatingWithIcon ? (
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 0.5,
                }}
              >
                <NWGreenIcon
                  sx={{
                    display: 'flex',
                    flexShrink: 0,
                    lineHeight: 0,
                    '& svg': { display: 'block' },
                  }}
                />
                <Box component="span" sx={{ lineHeight: 1 }}>
                  Rating
                </Box>
              </Box>
            ) : (
              heading.label
            )}

            {heading.labelTooltip && !shouldUseRatingWithIcon && (
              <Box component="span" sx={{ display: 'inline', whiteSpace: 'nowrap' }}>
                &nbsp;
                <DisclosureTooltip
                  trigger={
                    <Link
                      aria-label={heading?.label ?? 'info'}
                      component="button"
                      color="text.primary"
                      variant="textSmall"
                    >
                      <HelpOutline />
                    </Link>
                  }
                >
                  <Typography variant="textSmall">{heading.labelTooltip}</Typography>
                </DisclosureTooltip>
              </Box>
            )}
          </TableCell>
        );
      })}
      <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Learn more</TableCell>
    </TableRow>
  );
}
